var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"record"},[_c('div',{staticClass:"dot"}),_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.$t('meeting.recording')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }